var isUndefined = function (value) {
  return value === undefined;
};
export default isUndefined;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/is-undefined.js
// module id = 92
// module chunks = 0